/* global Survey */
import { getTakiwa } from "./config/takiwa";
import { getHapu } from "./config/hapu";

export async function initMaraePicker() {
    const takiwa = await getTakiwa();
    const hapuData = await getHapu();

    function maraeClickHandler(event) {
        let $target = $(event.target);
        while (!$target.hasClass("col-sm-3")) {
            $target = $target.parent();
        }
        $(".marae-picker-picked").removeClass("marae-picker-picked");
        $target.addClass("marae-picker-picked");
        const ret = {
            marae: $($target.children()[0]).text().trim(),
            maraeId: $target[0].dataset.maraeId,
            takiwa: $target.children().attr("data-takiwa"),
            takiwaId: $target[0].dataset.takiwaId,
        };

        try {
            const hapuIds = $target[0].dataset.hapuId.split(",");

            const hapu = $($target.children()[1]).text();
            // If there are more than one hapū, leave it blank another question will gather it
            if (hapuIds && hapuIds.length === 1) {
                ret.hapu = hapu;
                ret.hapuId = hapuIds[0];
            }

            widget.question.value = ret;
        } catch (e) {
            console.warn(e);
        }
    }

    function auaHandler() {
        widget.question.value = "aua";
    }

    window.hapuData = hapuData;
    const widget = {
        name: "maraePicker",
        title: "Marae Picker",
        iconName: "",
        widgetIsLoaded: function () {
            return true;
        },
        isFit: function (question) {
            return question.getType() === "maraepicker";
        },
        activatedByChanged: function () {
            Survey.JsonObject.metaData.addClass(
                "maraepicker",
                [],
                null,
                "text"
            );
        },
        isDefaultRender: false,
        htmlTemplate: `
      <div class="marae-picker-container">
        <div class="row">
          ${takiwa
              .map(
                  (takiwaItem) => `
            <div class="col-sm-3">
              <div class="marae-picker-takiwa" data-id="${takiwaItem.id}">${takiwaItem.description}</div>
            </div>
            `
              )
              .join("\n")}
        </div>
        ${[0, 1, 2, 3]
            .map(
                (x) => `
          <div class="row clickable">
          ${[0, 1, 2, 3]
              .map((y) =>
                  takiwa[y].marae[x] === null
                      ? '<div class="col-sm-3"></div>'
                      : `
          <div class="col-sm-3" data-takiwa-id="${
              takiwa[y].id
          }" data-marae-id="${takiwa[y].marae[x].id}" data-hapu-id="${takiwa[
                            y
                        ].marae[x].hapu
                            .map((hapuItem) => hapuItem.id)
                            .join(",")}">
            <div class="marae-picker-marae" data-takiwa="${
                takiwa[y].description
            }">${takiwa[y].marae[x].description}</div>
            <div>${takiwa[y].marae[x].hapu
                .map((hapu) => `<em>${hapu.description}</em>`)
                .join("<br/>")}</div>
          </div>
        `
              )
              .join("\n")}
          </div>
          `
            )
            .join("\n")}
        <br />
        <div class="row clickable">
        <div class="col-sm-3"></div>
        <div class="col-sm-3"></div>
        <div class="col-sm-3"></div>
            <div class="marae-picker-marae || col-sm-3 aua-button">
                <div style="padding: 7px 12px;">I don't know</div>
            </div>
        </div>
      </div>`,
        afterRender: function (question) {
            widget.question = question;

            $(".marae-picker-marae").each(function () {
                // Calling off, makes sure we don't register it multiple times
                $(this)
                    .parent()
                    .off("click", maraeClickHandler)
                    .on("click", maraeClickHandler);
            });

            $(".aua-button").off("click", auaHandler).on("click", auaHandler);
        },
        question: {},
        willUnmount: function () {
            return null;
        },
    };

    Survey.CustomWidgetCollection.Instance.addCustomWidget(
        widget,
        "customtype"
    );

    $("#start-register").attr("disabled", false);
}
